import { Stack } from '#core/components';
import {
  DashboardIcon,
  HomeIcon,
  NotebookIcon,
  TaskListIcon
} from '#core/components/icons';
import { NavLink } from '../components';

export const Main = () => {
  return (
    <Stack>
      <NavLink leftSection={<HomeIcon />} to="/">
        Home
      </NavLink>
      <NavLink leftSection={<NotebookIcon />} to="/notebooks">
        Notebooks
      </NavLink>
      <NavLink leftSection={<TaskListIcon />} to="/task-lists">
        Task lists
      </NavLink>
      <NavLink leftSection={<DashboardIcon />} to="/dashboards">
        Dashboards
      </NavLink>
    </Stack>
  );
};
